import axios from "axios";
import { getAuth } from "firebase/auth";

class DigitalSignService {

  static endpoint =
    "https://europe-west3-hyper-e122e.cloudfunctions.net/set_company_digital_sign";

  static async setCompanyDigitalSign() {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        throw new Error(
          "Пользователь не авторизован."
        );
      }

      console.log(
        "🔐 Получаем токен для электронной подписи..."
      );

      const token = await user.getIdToken(true);

      if (!token) {
        throw new Error(
          "Не удалось получить токен авторизации."
        );
      }

      const payload = {
        app_version: this.getAppVersion(),
        platform: "web",
        device_id: this.getDeviceId()
      };

      console.log(
        "📤 SET DIGITAL SIGN REQUEST:",
        payload
      );

      const response = await axios.post(
        this.endpoint,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },

          timeout: 30000
        }
      );

      console.log(
        "✅ SET DIGITAL SIGN RESPONSE:",
        response.data
      );

      if (!response.data?.id) {
        throw new Error(
          "Сервер не вернул идентификатор электронной подписи."
        );
      }

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Не удалось создать электронное подтверждение.";

      console.error(
        "❌ SET DIGITAL SIGN ERROR:",
        {
          status: error.response?.status,
          data: error.response?.data,
          message
        }
      );

      const serviceError = new Error(message);

      serviceError.status =
        error.response?.status || null;

      throw serviceError;
    }
  }

  static getAppVersion() {
    return (
      process.env.VUE_APP_VERSION ||
      process.env.VUE_APP_BUILD_VERSION ||
      "web"
    );
  }

  static getDeviceId() {
    const storageKey =
      "hr3_web_device_id";

    try {
      let deviceId =
        localStorage.getItem(storageKey);

      if (deviceId) {
        return deviceId;
      }

      deviceId =
        this.generateDeviceId();

      localStorage.setItem(
        storageKey,
        deviceId
      );

      return deviceId;
    } catch (error) {
      console.warn(
        "⚠️ Не удалось сохранить device_id:",
        error
      );

      return this.generateDeviceId();
    }
  }

  static generateDeviceId() {
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      return crypto.randomUUID();
    }

    return [
      Date.now(),
      Math.random()
        .toString(36)
        .substring(2),
      Math.random()
        .toString(36)
        .substring(2)
    ].join("-");
  }
}

export default DigitalSignService;